import { useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';
import classNames from 'classnames';
import { Dropdown } from '@schibsted-svp/react-ui';

import { UserContext } from '../../../contexts/UserContext';

import type { FC } from 'react';

import styles from './Menu.module.scss';

const Menu: FC = () => {
  const { user } = useContext(UserContext);

  return (
    <nav className={styles.Menu}>
      <NavLink
        to="/pages"
        className={({ isActive }) =>
          classNames(styles.MenuItem, { [styles.MenuItemActive]: isActive })
        }
      >
        Pages
      </NavLink>
      <NavLink
        to="/components"
        className={({ isActive }) =>
          classNames(styles.MenuItem, { [styles.MenuItemActive]: isActive })
        }
      >
        Components
      </NavLink>
      <NavLink
        to="/tags"
        className={({ isActive }) =>
          classNames(styles.MenuItem, { [styles.MenuItemActive]: isActive })
        }
      >
        Tags
      </NavLink>
      <NavLink
        to="/assets"
        className={({ isActive }) =>
          classNames(styles.MenuItem, { [styles.MenuItemActive]: isActive })
        }
      >
        Assets
      </NavLink>
      <NavLink
        to="/categories"
        className={({ isActive }) =>
          classNames(styles.MenuItem, { [styles.MenuItemActive]: isActive })
        }
      >
        Categories
      </NavLink>
      <NavLink
        to="/editors"
        className={({ isActive }) =>
          classNames(styles.MenuItem, { [styles.MenuItemActive]: isActive })
        }
      >
        Editors
      </NavLink>
      <Dropdown variant="standard" label="Features">
        <Link to="/pictures">
          <Dropdown.Item itemKey="2">Promotion picture</Dropdown.Item>
        </Link>
        {user?.role === 'admin' && (
          <Link to="/users">
            <Dropdown.Item itemKey="1">Users</Dropdown.Item>
          </Link>
        )}
      </Dropdown>
    </nav>
  );
};

export { Menu };
